/* REACT PACKAGE IMPORTS */
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Button } from "react-bootstrap";

/* MUI PACKAGE IMPORTS */
// import { Button } from "@mui/material";

/* INTERNAL IMPORTS */
import { flattenArr } from "../../Utilities/tools.js";
import SideModal from "./SideModal";

export default function SessionPages() {
  const mounted = useRef(null);
  const modalLegendStyling = "text-base mb-0 flex gap-2 my-1 items-center";

  const [isPagesModalVisible, setIsPagesModalVisible] = useState(false);

  const { questions } = useSelector((store) => store.assessments);
  const { answersSaved, taggedQuestions } = useSelector(
    (store) => store.sessions
  );

  const getTotalQuestions = () => {
    let questionsArray = questions.map((question) => question.questions);
    let mergedQuestions = [].concat
      .apply([], questionsArray)
      .map((question) => question.questions);
    let totalQuestions = flattenArr(mergedQuestions);
    return totalQuestions;
  };

  const totalBlocks = getTotalQuestions();
  const progress = answersSaved?.filter(
    (answer) =>
      answer?.answercontent?.multichoice?.length > 0 ||
      answer?.answercontent?.singlechoice
  ).length;

  const scrollToNext = (id) => {
    const nextElement = document.getElementById(`container-${id}`);

    if (nextElement) {
      nextElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  useEffect(() => {
    mounted.current = true;
    if (!mounted.current) return;

    const focusedQuestion = sessionStorage.getItem("focusedQuestion");
    if (focusedQuestion) scrollToNext(focusedQuestion);

    return () => {
      mounted.current = false;
    };
  }, [isPagesModalVisible]);

  return (
    <>
      <Button
        className="p-2 px-3 text-nowrap inter w-fit"
        variant="outline-dark"
        onClick={() => {
          sessionStorage.removeItem("focusedQuestion");
          setIsPagesModalVisible(true);
        }}
      >
        View Progress
      </Button>
      <SideModal
        title={"Assessment progress"}
        isVisible={isPagesModalVisible}
        setIsVisible={setIsPagesModalVisible}
      >
        <p className={modalLegendStyling}>
          <span className="h-4 w-4 bg-[#00693C] rounded-sm"></span>
          Answered: {progress} of {totalBlocks?.length}
        </p>
        <p className={modalLegendStyling}>
          <span className={"h-4 w-4 bg-[#FFCC00] rounded-sm"}></span>
          Flagged for review: {taggedQuestions?.length} of {totalBlocks?.length}
        </p>
        <p className={modalLegendStyling}>
          <span className="h-4 w-4 bg-black rounded-sm"></span>
          Incomplete: {totalBlocks?.length - progress} of {totalBlocks?.length}
        </p>
        <div className="w-full max-w-md my-3">
          <div className="relative h-4 bg-black rounded-full overflow-hidden">
            <div
              className="h-full bg-[#00693C]"
              style={{ width: `${(progress / totalBlocks?.length) * 100}%` }}
            />
            <div
              className="absolute top-0 h-full bg-[#FFCC00]"
              style={{
                left: `${(progress / totalBlocks?.length) * 100}%`,
                width: `${
                  (taggedQuestions?.length / totalBlocks?.length) * 100
                }%`,
              }}
            />
          </div>
        </div>
        <div className="w-fit grid grid-cols-5 gap-2 mx-20 my-4">
          {totalBlocks.map((question, i) => {
            return (
              <div
                key={i}
                className={`flex justify-center items-center w-8 aspect-square ${
                  taggedQuestions.includes(question.qid)
                    ? "bg-[#FFBE45]"
                    : answersSaved.some(
                        (answer) =>
                          answer.qid === question.qid &&
                          (answer.answercontent.multichoice?.length > 0 ||
                            answer.answercontent.singlechoice)
                      )
                    ? "bg-[#00693C]"
                    : "bg-black"
                } rounded-sm text-white cursor-pointer`}
                onClick={() => {
                  sessionStorage.setItem("focusedQuestion", question.qid);
                  setIsPagesModalVisible(false);
                }}
              >
                {i + 1}
              </div>
            );
          })}
        </div>
      </SideModal>
    </>
  );
}
